import { render } from "./ClientPanel.vue?vue&type=template&id=40e66666&ts=true"
import script from "./ClientPanel.vue?vue&type=script&lang=ts"
export * from "./ClientPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__